import { render, staticRenderFns } from "./field.component.vue?vue&type=template&id=5d324628&scoped=true&lang=pug"
import script from "./field.component.vue?vue&type=script&lang=ts"
export * from "./field.component.vue?vue&type=script&lang=ts"
import style0 from "./field.component.vue?vue&type=style&index=0&id=5d324628&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d324628",
  null
  
)

export default component.exports